import { includes } from 'lodash';

import { ClaimPaymentDO } from './../../../BaseFramework/shared/models/payment.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip } from 'rxjs';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';


import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  ArrayManipulations,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import * as moment from 'moment/moment';


export interface ClientList {
  selectedClientData,
  fetchedClientData
}

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

export interface EmitterObject {
  role,
  clientList,
  targetInfo?
}
@Component({
  selector: 'app-captured-client-list',
  templateUrl: './captured-client-list.component.html',
  styleUrls: ['./captured-client-list.component.scss'],
  providers: [TechnicalTranslatePipe]
})
export class CapturedClientListComponent implements OnInit {

  _currentComponentName = 'CapturedClientListComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private policyService: PolicyService,
    private arrayManipulations: ArrayManipulations,
    public appMetadataHandler: AppMetadataHandler,
    private technicalTranslatePipe: TechnicalTranslatePipe
  ) {
    this.environment = environment
  }

  //Declaraions which might need developer input

  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'insuredCd', 'relationCd','nomineeForAppointeeCd']
  selectorOfThisComponent = 'app-captured-client-list'
  allowedRoleTypes = {
    NOMINEE: 'Nominee',
    CLAIMANT: 'Claimant',
    OWNER: 'Policy Holder',
    PAYER: 'Payer',
    INSURED: 'Additional Insured',
    VEHICLE: 'Vehicle',
    MEMBERS: 'Members',
    PRIMARYINSURED: 'Primary Insured',
    AGENT: 'Agent',
    APPOINTEE: 'Appointee'
  }
  parentEvent$
  environment


  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs
  @Output() changedField = new EventEmitter<any>()

  @Output() componentOutput = new EventEmitter<any>();
  @Output() clientEmitterToCopy = new EventEmitter<any>();
  @Output() openSearchModal = new EventEmitter<any>();
  @Output() updateClientList = new EventEmitter<any>();
  @Output() emittedClient = new EventEmitter<any>();
  @Output() emittedClientList = new EventEmitter<any>();
  
  @Output() payerDataSet = new EventEmitter<any>();
  @Input() configData
  private _copySource
  @Input()
  set copySource(value) {
    if (!value) {
      this._copySource = { selectedClientData: [], fetchedClientData: [] }
    }
    else {
      this._copySource = this.commonUtilty.deepCopy(value);
    }
  }

  get copySource() {
    if (this._copySource)
      return this._copySource
    else
      return { selectedClientData: [], fetchedClientData: [] }
  }

  get copySourceWithRemove() {
    let outputCopySource = this.commonUtilty.deepCopy(this._copySource)
    if (this._clientList && outputCopySource) {
      let clientListCopy = this.commonUtilty.deepCopy(this._clientList)
      let _selectedClientData = clientListCopy.selectedClientData.map(selectedClient => {
        selectedClient['remove'] = true
        return selectedClient
      });
      let _fetchedClientData = clientListCopy.fetchedClientData.map(fetchedClient => {
        fetchedClient['remove'] = true
        return fetchedClient
      });
      outputCopySource.selectedClientData.push(..._selectedClientData);
      outputCopySource.fetchedClientData.push(..._fetchedClientData);
    }
    if (outputCopySource)
      return outputCopySource
    else
      return { selectedClientData: [], fetchedClientData: [] }
  }
  _clientCount = null;
  clientCanBeAddedCount = 0;

  formatterPercent = value => `${value || 0} %`;
  parserPercent = value => value.replace(' %', '');

  @Input() type: string;
  @Input() operationMode: any;
  @Input() shareDataToMultiBank: any;
  @Input() sourceRole: string;
  @Input() allowClientToBeCopied: boolean;
  @Input() allowClientToBeInsuredOwner: boolean;
  @Input() allowClientToCaptureRelationship: boolean;
  @Input() allowClientToBePrimaryInsured: boolean
  @Input() allowEditInsured: boolean;
  @Input() enableSplitPercentage: boolean
  @Input()
  set allowedCount(value) {
    this.clientCanBeAddedCount = value;
    this._clientCount = value ? `Number of ${this._captureRole} allowed: ${value}` : 'N.A';
  };

  get allowedCount() {
    return this.clientCanBeAddedCount;
  }
  @Input() transactionState: string
  @Input() disableSearchAddButton: boolean
  @Input() disableClientEdit: boolean
  @Input() disableClientRemove: boolean
  @Input()
  set disableAllButtons(value) {
    this.disableClientEdit = this.disableClientEdit = this.disableClientRemove = !!value
  }

  @Input() enableClientAsPayee: boolean
  @Input() enableClientAsPayer: boolean
  @Input() addNominee : boolean = false;
  private _clientList: ClientList
  // disable button when data bind from set clientList
  disabledButtonclientListExists = false;

  @Input()
  set clientList(value: ClientList) {

    if (value == null || (Array.isArray(value) && value.length == 0))
      this._clientList = { selectedClientData: [], fetchedClientData: [] }
    else {
      if (this.operationMode === "MULTI" && this._clientList) {
        if (this._clientList['fetchedClientData'] && this._clientList['fetchedClientData'].length) {
          let clientList = this.commonUtilty.deepCopy(this._clientList)
          clientList.fetchedClientData.push(...value.fetchedClientData)
          clientList.selectedClientData.push(...value.selectedClientData)
          let uniqueSelectedClientData = this.arrayManipulations.getUniqueElements(clientList.selectedClientData, 'guid')
          let uniqueFetchedClientData = this.arrayManipulations.getUniqueElements(clientList.fetchedClientData, 'guid')
          this._clientList = { selectedClientData: uniqueSelectedClientData, fetchedClientData: uniqueFetchedClientData }

        }
        else {
          this._clientList = value
        }

      }
      else {
        if (value && value.selectedClientData && value.selectedClientData.length)
          this._clientList = value
        // else {
        //   throw `More than one client added in SINGLE Operation Mode for ${this._captureRoleKey} in ${this.getCurrentComponentName()}`;
        // }
      }

      if(value && this.commonUtilty.isArrayIterable(value.selectedClientData) && value.selectedClientData.length && !this.commonUtilty.isArrayIterable(this.appMetadataHandler.insuredLookupForNominee['insuredCd'])){
        value.selectedClientData.forEach(client => {
          let name = client.firstName + " " + client.lastName;
          this.appMetadataHandler.insuredLookupForNominee['insuredCd'].push({
            "lookupKey": client.guid,
            "lookupCd": "insuredCd",
            "lookupValue": name,
            "sortOrder": null,
            "criteriaLookupKey": null
          })
        });
      }
      if(value && this.commonUtilty.isArrayIterable(value.selectedClientData) && value.selectedClientData.length < 1){
        this._clientList = value
      }
    }

  }
  get clientList(): ClientList {
    if (this.enableCopy &&
      this.copySource &&
      Array.isArray(this.copySource.selectedClientData) &&
      this.copySource.selectedClientData.length > 0)
      return this.copySourceWithRemove
    else
      return this._clientList
  }
  _IO: any;
  @Input() set IO (value: any){
    if(value){
      // this.getConfigDataAndInitialize()
      this._IO = value
    }
  }

  // set operationMode(value: any) {
  //   this._operationMode=value;
  // }
  // get operationMode() {
  //   return this._operationMode;
  // }

  clientRole
  isCopiedFromOtherSource: boolean = this.copySource && Array.isArray(this.copySource.selectedClientData) && this.copySource.selectedClientData.length == 0
  _enableCopy: any = false;
  @Input()
  set enableCopy(flag: any) {
    if (this.clientList && this.sourceRole) this._enableCopy = flag
    else
      throw "Mode Set To Copy but Invalid Copy Source";
  }
  get enableCopy() { return this._enableCopy; }


  _captureRole: string;
  _captureRoleKey: string;
  @Input()
  set captureRole(role: string) {
    this._captureRoleKey = role
    if (this.allowedRoleTypes[role] === null) throw "Invalid Role Recieved"
    else
      this._captureRole = this.allowedRoleTypes[role];

  }
  get captureRole() { return this._captureRole; }

  @Input()
  set inputDataForEdit(genericList: string) {
    if (genericList) {
      let genericClientList = [];
      let primaryinsured = genericList['PRIMARYINSURED'] || [];
      let insured = genericList['INSURED'] || [];
      genericClientList = [...primaryinsured, ...insured];
      if (this.commonUtilty.isArrayIterable(genericClientList)) {
        genericClientList.forEach(client => {
          let name = client.personDO?.firstName + " " + client.personDO?.lastName;
          this.commonUtilty.addLookupDataToCache(client.guid, name, "insuredCd");
        })
      }
    }

    this.lookupDataService.getLookup('insuredCd',false).subscribe(item => {
      this.appMetadataHandler.insuredLookupForNominee['insuredCd'] = JSON.parse(JSON.stringify(item));      
    });

    let getNomineeListForAppointee = this.extractNomineeListForAppointee(genericList);
    if (this.sourceRole && this.copySource && this.copySource.selectedClientData && this.copySource.selectedClientData.length > 0) {
      this.copySource = this.mapAndSetClientListFromGenericList(genericList, this.sourceRole)
    }
    else {
      this.clientList = this.mapAndSetClientListFromGenericList(genericList, this._captureRoleKey)
    }

    let isSourceAndClientListEqual = this.checkIfCopySourceAndClientListAreEqual(this.clientList, this.copySource)
    if (this.enableCopy && isSourceAndClientListEqual) {
      this.copyFromDifferentSource = true
    }
    if (this.clientList)
      this.interactService.sendNomineeListToBankDetails(this.clientList.selectedClientData);
  }

  checkIfCopySourceAndClientListAreEqual(clientList: ClientList, copySource: ClientList) {
    if (clientList) {
      var isLengthEqual = clientList.selectedClientData.length == copySource.selectedClientData.length
      let isDataSame

      for (const client of clientList.selectedClientData) {
        let findResult = copySource.selectedClientData.find(selectedClient => selectedClient.id == client.id)

        if (!findResult && isLengthEqual)
          return false;
      }

      return true
    }
  }

  mapAndSetClientListFromGenericList(genericList, roleCd): ClientList {
    console.log("generic list 1", genericList);
    if (genericList) {
      let selectedClientData = this.extractSelectedClientDataWithPayerAndCopySource(genericList, roleCd);
      let fetchedClientData = genericList[roleCd] || []
      return { selectedClientData: selectedClientData, fetchedClientData: fetchedClientData }
    }
    else {
      return { selectedClientData: [], fetchedClientData: [] }
    }
  }

  private extractSelectedClientDataWithPayerAndCopySource(genericList: any, roleCd: any) {
    let selectedClientData
    if (this.enableCopy && this.sourceRole)
      selectedClientData = this.commonUtilty.mapperToCreateClientList(genericList['EMITTEDCLIENT']);
    else
      selectedClientData = this.commonUtilty.mapperToCreateClientList(genericList[roleCd]);
    selectedClientData = this.markIsSelectedAsCopySource(genericList, roleCd, selectedClientData);
    selectedClientData = this.markIsPayee(genericList, selectedClientData, roleCd);
    return selectedClientData;
  }

  markIsSelectedAsCopySource(genericList, roleCd, selectedClientData: Array<any>) {
    if (genericList && selectedClientData) {
      let emittedClientGuid
      if (Array.isArray(genericList['PRIMARYINSURED']))
        emittedClientGuid = genericList['PRIMARYINSURED'].find(clientGuid => true) || []
      selectedClientData.forEach(selectedClient => {
        if (selectedClient && emittedClientGuid && selectedClient['guid'] === emittedClientGuid['guid']) {
          selectedClient['isSelectedAsCopySource'] = true;
          // If Source is present then CopySource has to be populated in Edit scenario or else Remove button Stays active
          if (this.captureRole) {
            let output: ClientList = { selectedClientData: [selectedClient], fetchedClientData: genericList[roleCd] }
            this.copySource = this.commonUtilty.deepCopy(output)
          }
        }
      })
    }
    return selectedClientData
  }

  markIsPayee(genericList, selectedClientData: Array<any>, roleCd) {

    if (genericList && selectedClientData && roleCd) {
      let payeeClientGuids: Array<any> = genericList['PAYER']
      selectedClientData.forEach(selectedClient => {
        if(this.commonUtilty.isArrayIterable(payeeClientGuids)){
          payeeClientGuids.forEach(payeeGuid => {
            if (selectedClient && payeeGuid['guid'] === selectedClient['guid']){
              if(payeeGuid['remove']) {
                selectedClient['isPayee'] = false;
              }
              else selectedClient['isPayee'] = true;
              selectedClient['isSelectedAsCopySource'] = selectedClient['isSelectedAsCopySource'] ? selectedClient['isSelectedAsCopySource'] : payeeGuid['isSelectedAsCopySource']
              // if(payeeGuid['remove']) selectedClient['remove'] = payeeGuid['remove']  
            }
            this.emitPayeeIfFound(genericList, roleCd, selectedClient);
          })
        }
      })
    }
    return selectedClientData
  }

  clientZeroState = {
    title: `No ${this.captureRole} selected`,
    message: `No ${this.captureRole} was found for this case.`,
    icon: null
  }

  private emitPayeeIfFound(genericList: any, roleCd: any, selectedClient: any) {
    let fetchedClientData = genericList[roleCd];
    if (fetchedClientData && Array.isArray(fetchedClientData)) {
      let fetchedClientDataItem = fetchedClientData.filter(fetchedClient => fetchedClient['guid'] == selectedClient['guid']);
      if (this.commonUtilty.isArrayIterable(fetchedClientDataItem))
        this.onChangeIsPayee(selectedClient, fetchedClientDataItem, true);
    }
  }

  set inputDataForNewClient(client: string) {
    let clientDO = client['clientDO']
    let selectedClientDataArray = this.commonUtilty.mapperToCreateClientList([clientDO])
    let selectedClientData
    if (selectedClientDataArray && Array.isArray(selectedClientDataArray))
      selectedClientData = selectedClientDataArray.find(item => true);

    let fetchedClientDataArray = [clientDO]
    let fetchedClientData
    if (fetchedClientDataArray && Array.isArray(fetchedClientDataArray))
      fetchedClientData = fetchedClientDataArray.find(item => true);

    if(client['role'] == 'Policy Holder' ){
      this.clientList['selectedClientData'] = [selectedClientData];
      this.clientList['fetchedClientData'] = [fetchedClientData];
    }
    else if (this.clientList['selectedClientData'] && this.clientList['selectedClientData'].length == 0) {
      this.clientList['selectedClientData'].push(selectedClientData);
      this.clientList['fetchedClientData'].push(fetchedClientData);

    } else {

      const modifiedSelectedClientData = this.pushUniqueOverriddenValue(this.clientList['selectedClientData'], selectedClientData)
      this.clientList['selectedClientData'] = this.commonUtilty.deepCopy(modifiedSelectedClientData.modifiedList)
      selectedClientData = this.commonUtilty.deepCopy(modifiedSelectedClientData.item)
      let modifiedFetchedClientData = this.pushUniqueOverriddenValue(this.clientList['fetchedClientData'], fetchedClientData)
      this.clientList['fetchedClientData'] = this.commonUtilty.deepCopy(modifiedFetchedClientData.modifiedList)
      fetchedClientData = this.commonUtilty.deepCopy(modifiedFetchedClientData.item)
      // if (selectedClientData && selectedClientData['isSelectedAsCopySource']) {
      //   this.onChangeIsCopySource(selectedClientData, true)
      // }
      // if (selectedClientData && selectedClientData['isPayee']) {
      //   this.onChangeIsPayee(selectedClientData, fetchedClientData, true, true)
      // }
    }
  }

  pushUniqueOverriddenValue(p, m) {
    let overRiddenObject
    if (p && Array.isArray(p) && m && m.guid) {
      let index = p.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1) {
        let old_m = p[index]
        overRiddenObject = Object.assign({}, old_m, m)
        p.splice(index, 1, overRiddenObject)
      }
      else {
        p.push(m)
      }
    }
    return {
      modifiedList: p, item: overRiddenObject
    }
  }

  set inputDataForNewClient_old(clientDO: string) {
    console.log("client list", JSON.stringify(this.clientList));
    let selectedClientData = this.commonUtilty.mapperToCreateClientList([clientDO])
    let fetchedClientData = [clientDO]

    // if (this.clientList && this.clientList.fetchedClientData.isArrayIterable() && this.clientList.selectedClientData.isArrayIterable()) {
    //   this.clientList['selectedClientData'] = selectedClientData
    //   this.clientList['fetchedClientData'] = fetchedClientData
    // } else {
    this.clientList['selectedClientData'].push(...selectedClientData)
    this.clientList['fetchedClientData'].push(...fetchedClientData)
    // }

    console.log("captured client or agent list", JSON.stringify(this.clientList));
  }




  // removeClientSubscription$
  // intializeRemoveClientSubscription() {
  //   if (this.removeClientSubscription$) this.removeClientSubscription$.unsubscribe()
  //   this.removeClientSubscription$ = this.interactService.removeClientSubject$.subscribe(resp => {
  //     if (resp['role'] === this._captureRoleKey) {
  //       if (resp['index'] && resp['list']) {
  //         this.localRemoveClientSorted(resp['index'], resp['list'])
  //       }
  //       else {
  //         this.localRemoveClientUnsorted(resp['clientDO'], resp['list'], 'guid')
  //       }

  //     }
  //   })
  // }

  _mapperToCreateClientList(fetchedClientData) {

    let output = [];

    if (fetchedClientData) {
      fetchedClientData.forEach(fetchedClientDO => {

        let selectedClientDO = this._selectedClientDOFromFetchedClientDO(fetchedClientDO)

        output.push(this.commonUtilty.deepCopy(selectedClientDO))

      });
    }
    return output

  }

  _selectedClientDOFromFetchedClientDO(fetchedClientDO) {
    let clientListItemDO = {
      clientNum: null,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      contactNum: null,
      emailId: null,
      id: null,
      guid: null,
      genderCd: null
    }
    if (fetchedClientDO) {
      let c = this.commonUtilty.deepCopy(clientListItemDO)
      c.clientNum = fetchedClientDO['clientNum']
      c.contactNum = this._getPrefferedContactFromClient(fetchedClientDO)
      c.emailId = this._getPrefferedEmailFromClient(fetchedClientDO)
      c.id = fetchedClientDO['id']
      c.guid = fetchedClientDO['guid']
      if (fetchedClientDO.clientTypeCd === 'PERSON') {
        c.firstName = this.commonUtilty.getFirstNameFromClient(fetchedClientDO)
        c.lastName = this.commonUtilty.getLastNameFromClient(fetchedClientDO)
        c.dateOfBirth = this.commonUtilty.getDateOfBirthFromClient(fetchedClientDO)
        c.genderCd = this.commonUtilty.getGenderFromClient(fetchedClientDO)
      }
      else if (fetchedClientDO.clientTypeCd === 'ORGANIZATION') {
        c.firstName = this.commonUtilty.getOrgCompanyNameFromClient(fetchedClientDO)
      }
      return this.commonUtilty.deepCopy(c)
    }
  }

  _getPrefferedContactFromClient(client) {
    if (client.clientContactDetailsList) {
      let contactDetails = client.clientContactDetailsList.find(contact => contact.prefferedFl)
      if (contactDetails) {
        return contactDetails.contactNum;
      }
      else {
        return null
      }
    }
    else {
      return null
    }

  }

  _getPrefferedEmailFromClient(client) {
    if (client.clientEmailList) {
      let emailDetails = client.clientEmailList.find(email => email.prefferedFl)
      if (emailDetails) {
        return emailDetails.emailId;
      }
      else {
        return null;
      }
    }
    else {
      return null
    }

  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
    console.log("captured client list component output", c);
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }
  private _copyFromDifferentSource: any = false;
  set copyFromDifferentSource(value: boolean) {

    if (value !== null) {
      this._copyFromDifferentSource = value;
      // if (this._copyFromDifferentSource) {
      //   this.triggerCopy(this.copySource);
      // }
      // else
      //   this.triggerCopy();

    }
    else
      this._copyFromDifferentSource = false


  }
  get copyFromDifferentSource(): boolean {
    return this._copyFromDifferentSource;
  }



  triggerCopy(data?) {
    if (data)
      this.clientList = data
    else
      this.clientList = { selectedClientData: [], fetchedClientData: [] };
    //throw "Mode Set To Copy but Invalid Copy Source";
  }

  setClaimantAsNominee() {

  }

  subscribeToNewClientCapture() {
    this.interactService.addClientSubject$.subscribe(res => {
      if (res.role === this.allowedRoleTypes[this._captureRoleKey]) {
        this.inputDataForNewClient = res
        // this.EmitUpdateClientList(this.clientList)
      }
    })
  }

  EmitUpdateClientList(clientList) {
    if (!clientList) {
      clientList = { selectedClientData: [], fetchedClientData: [] }
    }
    this.updateClientList.emit(clientList)
  }

  EmitOpenSearchModal() {
    this.openSearchModal.emit(false);
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }


  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((data: any) => {
      const matches = data.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(data) && this.commonUtilty.isArrayIterable(matches)) {
        console.log("client list for sending to parent component", JSON.stringify(this.clientList))
        let validationResult = this.validateOutput(this.clientList)
        if (!validationResult.isInvalid) {
          let output: EmitterObject = { role: this._captureRoleKey, clientList: this.clientList || [] }
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  validateOutput(o) {

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkAtleastOnePayeeIsSelected(o, validationOutput.errorDOs)
    if (this.enableSplitPercentage) {
      validationOutput.errorDOs = this.validationSplitPercentage(o, validationOutput.errorDOs)
    }
    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }
    return validationOutput
  }

  checkAtleastOnePayeeIsSelected(clientList, errorDOs) {
    let isTheValidationValid = this.validationUtilService.isRequired('payee', 'claimsCaptureNominee')
    if (isTheValidationValid && this.enableClientAsPayee) { //feature flag condition can be added here
      //Standard null checks
      if (clientList && clientList.selectedClientData && Array.isArray(clientList.selectedClientData)) {
        let foundPayee = this.clientList.selectedClientData.find(selectedClient => selectedClient['isPayee'])
        if (!foundPayee) {
          let errorDO = new ErrorDO();
          errorDO.errorMsg = this.validationUtilService.getErrorMsg('payee', 'claimsCaptureNominee');
          errorDO.fieldName = "payee";
          errorDO.fieldNameDescription = "Payee"
          errorDO.componentName = this.getCurrentComponentName();
          errorDOs.push(errorDO)
        }
      }
    }
    if (!isTheValidationValid) {
      console.log(` If Payee Validation is needed then please add below config to Client Validation {
          "state": null,
          "fieldName": "payee",
          "formName": "claimsCaptureNominee",
          "validation": "required",
          "valueForParameter": "null",
          "additionalParameter": "null",
          "type": "null",
          "errorMessage": "Atleast one Payee should be selected from the Nominee List"
        }`)
    }

    return errorDOs
  }

  /*validationSplitPercentage(clientList, errorDOs) {
    if (clientList && this.commonUtilty.isArrayIterable(clientList.selectedClientData)) {
      let totalPercentage = 0;
      clientList.selectedClientData.forEach(selectedClientItem => {
        if (!selectedClientItem['remove']) {
          if (!selectedClientItem.nomineeSplitPrct) {
            selectedClientItem.nomineeSplitPrct = 0
          } else {
            if (typeof selectedClientItem.nomineeSplitPrct == 'string')
              selectedClientItem.nomineeSplitPrct = parseInt(selectedClientItem.nomineeSplitPrct);
            if (typeof totalPercentage == 'string')
              totalPercentage = parseInt(totalPercentage);

            totalPercentage = totalPercentage + selectedClientItem.nomineeSplitPrct;
          }
        }
        else {
          selectedClientItem.nomineeSplitPrct = 0
        }
      });

      let noOfPayees = 0
      if (this.commonUtilty.isArrayIterable(clientList.selectedClientData)) {
        let payees = clientList.selectedClientData.filter(slclt => slclt['isPayee'])
        noOfPayees = payees.length
      }

      if (totalPercentage != 100) {
        let errorDO = new ErrorDO()
        errorDO.errorMsg = "Total of Split Percentages should be 100";
        errorDO.componentName = this.getCurrentComponentName();
        errorDO.fieldName = "Nominee Split Percentage";
        errorDO.fieldNameDescription = "Nominee Split Percentage"
        if (Array.isArray(errorDOs))
          errorDOs.push(errorDO);
      }
    }

    return errorDOs
  }*/

  validationSplitPercentage(clientList, errorDOs) {
    if (clientList && this.commonUtilty.isArrayIterable(clientList.selectedClientData)) {
      let insuredListOfNominee =  Array.from(new Map( clientList.selectedClientData.map(data => [data.nomineeForInsured, data.nomineeForInsured])).values());

      if (this.commonUtilty.isArrayIterable(insuredListOfNominee)) {

        insuredListOfNominee.forEach(insured => {
          /*let getTtlSplitPercent = clientList.selectedClientData.map(item => {
            let ttlSplitForInsured = 0;
            if (!item['remove'] && item.nomineeForInsured == insured) {
              ttlSplitForInsured += Number(item['nomineeSplitPrct']) ? item['nomineeSplitPrct'] : 0
            }
            return ttlSplitForInsured;
          });

          let calcTotalSplitPrct = getTtlSplitPercent.reduce((tot, curVal) => {
            return tot + curVal;
        })*/
        let calcTotalSplitPrct = clientList.selectedClientData.reduce((total, item) => {
          let ttlSplitForInsured = 0;
          if (!item['remove'] && item.nomineeForInsured == insured) {
            ttlSplitForInsured = Number(item['nomineeSplitPrct']) ? item['nomineeSplitPrct'] : 0
          }
          return total + ttlSplitForInsured;
        }, 0);

          // if (calcTotalSplitPrct != 100) {
          //   let errorDO = new ErrorDO()
          //   errorDO.fieldNameDescription = "Nominee Split Percentage"
          //   errorDO.errorMsg = "Total of Split Percentages should be 100 for Insured " ;
          //   errorDO.componentName = this.getCurrentComponentName();
          //   if (Array.isArray(errorDOs))
          //     errorDOs.push(errorDO);
          // }
        });
      }
      return errorDOs;
    }

  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  configPath = "/configs/health-nbu-transaction.json"
  // configData: any;

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.subscribeToParentEvent()
    this.subscribeToNewClientCapture()

    this.clientZeroState = {
      title: `No ${this.captureRole} selected`,
      message: `No ${this.captureRole} was found for this case.`,
      icon: null
    }

    console.log("_captureRoleKey", this._captureRoleKey);
    if (this._captureRoleKey == "NOMINEE")
      this.refreshNomineeList();

    // if (this._captureRoleKey == 'PAYER')
    // this.subscribeToAddPayee();
    // Commented above call because it's caused multiple fech policy call
    if (this.transactionState) {
      if (this.transactionState == 'proposal_DataEntry' || this.transactionState == 'MOTORproposal_DataEntry' ||
      this.transactionState == 'LIFEproposal_DataEntry' || this.transactionState == 'PROPERTYproposal_DataEntry' ||this.transactionState == 'TRAVELproposal_DataEntry') {
        this.disabledButtonclientListExists = false
      }
      else {
        this.disabledButtonclientListExists = true
      }
    }
  }

  getConfigDataAndInitialize() {
    // get configData from Assets
    this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
      this.configData = this.commonUtilty.deepCopy(response);
      if(response){
        this.setNomineeAndSplitPercentageForInsured()
      }
      // this.tabStates = this.commonUtilty.deepCopy(this.configData.tabStates)
      console.log("get config data checked: ", this.configData)
      // this.intializeTransaction();
    })
  }

  _getDOName(state) {
    if(this.configData){
      let output = this.configData.StateToDOMapper[state]
      let defaultClaimDOFeatureOnAndNoDOFoundInMapper = this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
      let defaultClaimDOFeatureOffAndNoDOFoundInMapper = !this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
      if (defaultClaimDOFeatureOnAndNoDOFoundInMapper) {
        return 'claimDO'
      }
      else if (defaultClaimDOFeatureOffAndNoDOFoundInMapper)
        throw "No Valid DO name for the state passed --" + state;
      else
        return output
    }

  }

  setNomineeAndSplitPercentageForInsured(){
    // this.getConfigDataAndInitialize();
    let DO = this._getDOName(this.transactionState)
    let clientListNodeName = this.configData.ClientListNodeMapper[this.transactionState]
    if (this.clientList && this.commonUtilty.isArrayIterable(this.clientList['selectedClientData'])
      && this._IO && this._IO[DO] && this.commonUtilty.isArrayIterable(this._IO[DO][clientListNodeName])) {
      this._IO[DO][clientListNodeName].forEach(cov => {
        this.clientList['selectedClientData'].forEach(ele => {
          if (cov.clientId == ele.id && cov.nomineeForInsured && !ele.nomineeForInsured) {
            ele.nomineeForInsured = cov.nomineeForInsured;
            ele.nomineeSplitPrct = cov.nomineeSplitPrct;
          }
          else if (cov.clientId == ele.id && cov.nomineeForInsured && ele.nomineeForInsured) {
            ele.nomineeForInsured = cov.nomineeForInsured
          }
        })
      })
    }
  }

  // Nominee List
  refreshNominee$
  refreshNomineeList() {
    if (this.refreshNominee$) this.refreshNominee$.unsubscribe()
    this.refreshNominee$ = this.interactService.policyListSubject$.subscribe(res => {
      this.fetchNomineeByPolicyList(res);
    });
  }
  nomineeList$ = null
  fetchNomineeByPolicyList(data) {
    //Remove previously populated clients via policy
    //Condition: Check if selectedClientData and fetchedClientData are valid Arrays
    if (Array.isArray(this._clientList.selectedClientData) && Array.isArray(this._clientList.fetchedClientData)) {
      this._clientList.selectedClientData = this._clientList.selectedClientData.filter(client => !!!client['isExtractedFromPolicy'])
      this._clientList.fetchedClientData = this._clientList.fetchedClientData.filter(client => !!!client['isExtractedFromPolicy'])
    }
    //Condition: If not valid arrays then initialize them as empty arrays
    else {
      this._clientList.selectedClientData = []
      this._clientList.fetchedClientData = []
    }
    if (this.nomineeList$) this.nomineeList$.unsubscribe()
    this.nomineeList$ = this.policyService.extractSpecificRolesUsingPolicyList(Object.assign([], data), "NOMINEE").subscribe(nomineeList => {
      if (nomineeList && nomineeList != null && nomineeList.length > 0 && this._captureRoleKey == "NOMINEE") {
        nomineeList.forEach(nominee => {
          let selectClientData = this.commonUtilty.selectedClientDOFromFetchedClientDO(nominee)
          //Check If the client already exists in the list
          let filtered = this._clientList.selectedClientData.find(item => item.clientNum == selectClientData.clientNum)
          //Clients extracted from policy to be directly added must be flagged so that the list can be refreshed everytime
          selectClientData['isExtractedFromPolicy'] = true;
          nominee['isExtractedFromPolicy'] = true

          //If client doesn't exist in the list, only then push
          if (!filtered && Array.isArray(this._clientList.selectedClientData) && Array.isArray(this._clientList.fetchedClientData)) {
            this._clientList.selectedClientData.push(selectClientData)
            this._clientList.fetchedClientData.push(nominee);
          }
        });

      }
    });
  }

  //End Nominee  list

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }


  removeClient(data, list, uniqueID) {
    this.EmitUpdateClientList(this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID));
  }

  localRemoveClientUnsorted(data, list, uniqueID) {
    // this.clientList['selectedClientData'] = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
    if (this.clientList['fetchedClientData']) {
      this.clientList['fetchedClientData'] = this.commonUtilty.removeItemFromListUnSorted(data, this.clientList['fetchedClientData'], uniqueID)
    }
    this.EmitUpdateClientList(this.clientList)
  }

  localRemoveClientSorted(index, list) {
    this.clientList = list.splice(index, 1)
  }

  emitClientAsCopySource(data, clientName) {
    let output: EmitterObject = { role: this._captureRoleKey, clientList: data, targetInfo: clientName };
    this.emittedClient.emit(output);
  }

  emitClientList(data , clientName){
    let output: EmitterObject = { role: this._captureRoleKey, clientList: data, targetInfo: clientName };
    this.emittedClientList.emit(output);
  }
  emitClientAsPayee(data) {
    console.log(data);
  }

  onChangeIsCopySource(data, event, targetRole) {
    this.deselectOtherClients(data, 'isSelectedAsCopySource');
    let clientToBeEmitted: ClientList = { selectedClientData: [], fetchedClientData: [] }
    if (event) {
      let extractedFetchedClientData = this.clientList.fetchedClientData.find(fetchedClient => fetchedClient['clientNum'] === data['clientNum']);
      if(data && extractedFetchedClientData){
        data['relationCd'] = 'SELF';
        extractedFetchedClientData['relationCd'] = 'SELF';
      }
      clientToBeEmitted = {
        selectedClientData: [data],
        fetchedClientData: [extractedFetchedClientData],
      }
      this.emitClientAsCopySource(clientToBeEmitted, targetRole);
    }
    else {
      this.emitClientAsCopySource(clientToBeEmitted, targetRole)
    }
    // let output = { role: 'PRIMARYINSURED', clientDO: data }
    // this.interactService.sendInsuredList(output);
  }

  payeeList: any = [];
  onChangeIsPayee(selectedClientDataItem, fetchedClientDataItem, event) {
    //this.deselectOtherClients(selectedClientDataItem, 'isPayee');
    if (event) {
      let paymentDo = new ClaimPaymentDO()
      paymentDo['clientRefGuid'] = selectedClientDataItem.guid;
      paymentDo['clientDO'] = fetchedClientDataItem
      let indexFound = this.payeeList.findIndex(item => {
        if (item)
          return item['clientRefGuid'] === selectedClientDataItem.guid;
      })
      if (indexFound === -1) {
        this.payeeList.push(paymentDo)
      }
      else {
        this.payeeList[indexFound]['clientDO'] = fetchedClientDataItem
      }
    }
    else {

      let output = this.payeeList.filter(item => {
        if (item)
          return item['clientRefGuid'] !== selectedClientDataItem.guid;
      }) || []

      this.payeeList = output;
    }
    this.interactService.sendPayeeListToBankDetails(this.payeeList);
  }

  deselectOtherClients(data, attrName) {

    if (data[attrName]) {
      this.clientList.selectedClientData.forEach(element => {
        if (data.id != element.id) element[attrName] = false
      });
    }

  }

  editClient(clientDO, mode) {
    clientDO['disabled'] = mode == 'view'
    this.openSearchModal.emit(clientDO);
  }

  // added by Abhishek, when Policy holder is Payer

  // payerList: any = []
  payeeListSubject$
  emitterHistory = {}
  subscribeToAddPayee() {
    console.log("capture role", this._captureRoleKey)
    if (this.payeeListSubject$)
      this.payeeListSubject$.unsubscribe()
    this.payeeListSubject$ = this.interactService.payeeListSubject$.subscribe(res => {
      console.log("subscribed to fetch payee list", JSON.stringify(res));
      if (res && Array.isArray(res)) {
        let refreshedPayeeList = this.commonUtilty.refreshPayeeList(this.payeeList, res);
        this.payeeList = this.commonUtilty.deepCopy(refreshedPayeeList)
        // this.clientList = this.payeeList;
        // this.subscribeToAllBankChildren(this.payeeList);
      }
    })
  }

  removeInsuredFromLookupCache(client) {
    console.log("client details", client);
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['insuredCd'])) {
      let clientToBeRemoved = client['selectedClientData'].find(item => item.remove);
      let foundIndex = this.lookupDataService.lookupCacheMap['insuredCd'].findIndex(item => item.lookupKey == clientToBeRemoved.guid)
      if (foundIndex != -1) {
        this.lookupDataService.lookupCacheMap['insuredCd'].splice(foundIndex, 1);
        this.appMetadataHandler.insuredLookupForNominee['insuredCd'].splice(foundIndex, 1);
      }
    }
    this.emitClientList(client , 'PAYER');
  }


  extractNomineeListForAppointee(genericList){
    if (genericList) {
      let genericClientList = [];
      let nomineeList = genericList['NOMINEE'] || [];
      if(this.commonUtilty.isArrayIterable(nomineeList)){
        nomineeList.forEach((nominee,index) => {
          nominee.age = nominee.personDO['age'] || this.calculateAge(nominee.dateOfBirth);
          /*if(nominee.age > 18){
            nomineeList.splice(index, 1);
          }*/
        });
        genericClientList = [...nomineeList.filter((person) => person.age < 18)];
      }
      if (this.commonUtilty.isArrayIterable(genericClientList)) {
        genericClientList.forEach(client => {
          let name = client.personDO.firstName + " " + client.personDO.lastName;
          this.commonUtilty.addLookupDataToCache(client.guid, name, "nomineeForAppointeeCd");
        })
      }
    }
  }

  calculateAge(DOB){
    var today = new Date();
    const [day, month, year] = DOB.split('/');
    const birthDate = new Date(+year, +month - 1, +day);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
   }
   formDataChangeHandler(fieldKey){
    // let me = this;
    // me.interactService.formFieldChangeSubject(fieldKey);
    this.changedField.emit(fieldKey);
  }
  
}


